import * as styles from "./ValidatedHoursNotice.css";

import { useAtomValue } from "jotai";
import type { JSX } from "react";

import { Trans } from "@lingui/react/macro";

import { selectedValidatedHoursAtom } from "../stores";

export function ValidatedHoursNotice(): JSX.Element | null {
  const notice = useAtomValue(selectedValidatedHoursAtom);

  if (null === notice) {
    return null;
  }

  const statuses = notice.statuses.map((entry) => entry.label).join(", ");

  return (
    <p className={styles.notice} role="status">
      <Trans>
        Hours with status "{statuses}" have already been validated for this
        period. They have to be changed by hand in the hours validation.
      </Trans>
    </p>
  );
}
